import type { SVGProp } from './types';

export const bitcoin = (props: SVGProp) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#clip0_755_22515)">
      <path
        d="M12 24c6.6274 0 12-5.3726 12-12 0-6.62742-5.3726-12-12-12C5.37258 0 0 5.37258 0 12c0 6.6274 5.37258 12 12 12Z"
        fill={props.color || '#F7931A'}
      />
      <path
        d="M17.3912 10.515c.2355-1.572-.9623-2.41725-2.5988-2.98125l.531-2.13-1.296-.3225-.5175 2.07375c-.3405-.0855-.69-.165-1.0387-.2445l.5212-2.08725L11.6964 4.5l-.531 2.12925c-.282-.0645-.5595-.1275-.828-.195l.0015-.00675-1.78796-.44625-.345 1.3845c0 0 .96225.2205.942.234.525.13125.6195.4785.60375.7545l-.6045 2.42625c.036.009.0825.0225.135.0427l-.13725-.0337-.8475 3.399c-.0645.159-.22725.3982-.59475.3075.0135.0187-.942-.2348-.942-.2348l-.6435 1.4836 1.6875.4207c.3135.0788.621.1612.92325.2385l-.53625 2.154 1.29525.3225.53096-2.13c.354.0952.6975.1837 1.0335.2677l-.5295 2.121 1.296.3226.5363-2.1495c2.211.4185 3.873.2497 4.5727-1.7498.564-1.6095-.0277-2.5387-1.191-3.144.8475-.195 1.485-.7522 1.6553-1.9035Zm-2.9625 4.1535c-.3998 1.6103-3.111.7395-3.99.5213l.7125-2.8538c.879.2197 3.6967.654 3.2775 2.3325Zm.4012-4.1767c-.3652 1.4647-2.6212.72-3.3525.5377l.645-2.5875c.7313.18225 3.0885.522 2.7075 2.0498Z"
        fill="#ddd"
      />
    </g>
    <defs>
      <clipPath id="clip0_755_22515">
        <rect width="24" height="24" fill="#ddd" />
      </clipPath>
    </defs>
  </svg>
);
